import Vue from 'vue';
import Vuex from 'vuex';
import chatStore from './chatStore.js';
import configStore from './configStore.js';
import friendStore from './friendStore.js';
import groupStore from './groupStore.js';
import uiStore from './uiStore.js';
import userStore from './userStore.js';

Vue.use(Vuex)

export default new Vuex.Store({
	modules: { chatStore, friendStore, userStore, groupStore, configStore, uiStore },
	state: {},
	mutations: {
	},
	actions: {
		load(context) {
			return this.dispatch("loadUser").then(() => {
				return this.dispatch("loadPinedChats").then(() => {
					const promises = [];
					promises.push(this.dispatch("loadFriend"));
					promises.push(this.dispatch("loadGroup"));
					promises.push(this.dispatch("loadGroupJoinRequests"));
					promises.push(this.dispatch("loadMyJoinRequests"));
					promises.push(this.dispatch("loadChat"));
					promises.push(this.dispatch("loadConfig"));
					return Promise.all(promises);
				})
			})
		},
		unload(context) {
			context.commit("clear");
		}
	},
	strict: process.env.NODE_ENV !== 'production'
})
